import { render, staticRenderFns } from "./DashboardAfiliado.vue?vue&type=template&id=458278e8&scoped=true&"
import script from "./DashboardAfiliado.vue?vue&type=script&lang=js&"
export * from "./DashboardAfiliado.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAfiliado.vue?vue&type=style&index=0&id=458278e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458278e8",
  null
  
)

export default component.exports